import { LayoutConfig } from '@spartacus/storefront';

export const breakpointsConfig: LayoutConfig = {
  breakpoints: {
    xxs: 0,
    xs: {
      min: 375,
    },
    sm: {
      min: 576,
    },
    md: {
      min: 768,
    },
    lg: {
      min: 1024,
    },
    xl: {
      min: 1280,
    },
    xxl: {
      min: 1440,
    },
  },
};
